var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.computedStyles),attrs:{"id":"app"}},[(_vm.routeName)?_c('Home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }